const SessionStorageUtils = () => {
  const getStorageData = (key: string) => {
    const storageData = sessionStorage.getItem(key)
    return storageData ? JSON.parse(storageData) : ''
  }
  const updateStorageData = (key: string, newData: Object | string) => {
    sessionStorage.setItem(key, JSON.stringify(newData))
  }

  const deleteStorageData = (key?: string) => {
    if (key !== undefined) {
      sessionStorage.removeItem(key)
    } else sessionStorage.clear()
  }

  return {
    getStorageData,
    updateStorageData,
    deleteStorageData,
  }
}

export default SessionStorageUtils
